import React from 'react';
import sx from '../../featured-posts/FeaturedPosts.module.scss';

import {AllWpPostsWithSlug} from '../../../../types/wordpress.types';
import {Card} from '../../card/Card.component';
import {LineHeader} from '../../line-header/LineHeader.component';
import {useIntl} from 'gatsby-plugin-intl';

interface ISimilarPosts {
  categoriesPosts: AllWpPostsWithSlug;
}

export const SimilarPosts = ({categoriesPosts}: ISimilarPosts) => {
  
  const intl = useIntl();
  
  return (
    <div className={sx.featuredPosts}>
      <LineHeader text={intl.formatMessage({id: 'post__similarArticles'})}/>
      <div className={sx.featuredPosts__cards}>
        {categoriesPosts.map((node, index) => {
          return <Card
            key={index}
            title={node.title}
            categories={node.categories}
            featuredImage={node.featuredImage}
            date={node.date}
            slug={node.slug}
          />
        })}
      </div>
    </div>
  );
};
